export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"description","content":"Parmazip Patient App - Connect with pharmacists, manage appointments, and access your health records"}],"link":[{"rel":"icon","type":"image/png","href":"/favicon.ico"},{"rel":"stylesheet","href":"https://maxst.icons8.com/vue-static/landings/line-awesome/line-awesome/1.3.0/css/line-awesome.min.css","media":"none","onload":"if(media!='all')media='all'"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Merriweather:wght@300;400;700;900&family=Open+Sans:wght@300;400;500;600;700&family=Hind+Siliguri:wght@400;500;600&family=Inter:wght@400;500;600;700&display=swap","media":"none","onload":"if(media!='all')media='all'"}],"style":[],"script":[{"type":"text/javascript","src":"https://cdnjs.cloudflare.com/ajax/libs/three.js/r134/three.min.js"},{"type":"text/javascript","src":"https://cdn.jsdelivr.net/npm/vanta/dist/vanta.net.min.js"}],"noscript":[],"title":"Parmazip - Patient Telehealth Platform"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000